import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Star, Quote, MapPin } from 'lucide-react';
import { AVIS, REALISATIONS } from '../data/temoignages';

const Testimonials = () => {
  if (AVIS.length === 0 && REALISATIONS.length === 0) return null;

  return (
    <section id="avis" className="py-20 bg-white scroll-mt-28" data-testid="temoignages-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
        {AVIS.length > 0 && (
          <div>
            <div className="text-center mb-10">
              <Badge className="mb-4 bg-green-100 text-green-700 hover:bg-green-100">Avis clients</Badge>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Ils nous font confiance</h2>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="avis-grid">
              {AVIS.map((a, i) => (
                <Card key={i} className="p-6 border-2 border-gray-100 relative">
                  <Quote className="absolute top-4 right-4 h-10 w-10 text-green-100" />
                  <div className="flex mb-3">
                    {Array.from({ length: a.note || 0 }).map((_, k) => <Star key={k} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed mb-4">« {a.texte} »</p>
                  <p className="font-bold text-gray-900 text-sm">{a.auteur}</p>
                  <p className="text-xs text-gray-500">{[a.role, a.source && `via ${a.source}`].filter(Boolean).join(' · ')}</p>
                </Card>
              ))}
            </div>
          </div>
        )}

        {REALISATIONS.length > 0 && (
          <div>
            <div className="text-center mb-10">
              <Badge className="mb-4 bg-green-100 text-green-700 hover:bg-green-100">Réalisations</Badge>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Nos dernières interventions</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="realisations-grid">
              {REALISATIONS.map((r, i) => (
                <Card key={i} className="overflow-hidden border-2 border-gray-100">
                  {r.image && <img src={r.image} alt={r.titre} className="w-full h-48 object-cover" loading="lazy" />}
                  <div className="p-5">
                    <p className="font-bold text-gray-900">{r.titre}</p>
                    <p className="text-sm text-gray-600 mt-1 inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-green-600" /> {r.lieu}{r.benne && ` · ${r.benne}`}</p>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
